// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aVbRTh98Kw8eDo {
  right: var(--ds-space-300, 24px);
  bottom: var(--ds-space-200, 16px);
  justify-content: right;
  transition: bottom 0.3s ease-in-out;
}
.aVbRTh98Kw8eDo.NRXBBXGVq6_6je {
  bottom: -100px;
}
.DyfHPvL1B0G2gg {
  padding: var(--ds-space-0, 0);
  border: none;
}
.__GEveDKZfjXUv {
  height: 675px;
}
`, ""]);
// Exports
export var container = `aVbRTh98Kw8eDo`;
export var isCardRoute = `NRXBBXGVq6_6je`;
export var buttonGroup = `DyfHPvL1B0G2gg`;
export var chatInterfaceContainer = `__GEveDKZfjXUv`;
export default ___CSS_LOADER_EXPORT___;
